import http, { HttpSuccessOrErrorType } from '../http';
import { FirstMenu, ResultSetHeader, SecondMenu } from '../../models';
import { SecondMenuString } from '../../models/second-menu-string.entity';
export default {
    /**
     * 创建单个second_menu资源。
     * @param params 参数
     */
    async post_restaurant_string_id_second_menu(params: SecondMenu & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params
        return await http.post(`/restaurant/${string_id}/second_menu`, {
            ...rest
        })
    },

    /**
     * 创建或者修改多个second_menu_string资源。
     * @param params 参数
     */
    async post_restaurant_string_id_second_menu_second_menu_strings(params: { string_id: string, ruleSetInfo: Array<SecondMenuString> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ruleSetInfo } = params
        return await http.post(`/restaurant/${string_id}/second_menu/second_menu_strings`, ruleSetInfo)
    },

    /**
     * 查询 所有 second_menu 资源
     * @param string_id 参数
     */
    async get_restaurant_string_id_second_menus(string_id: string): Promise<HttpSuccessOrErrorType<FirstMenu[]>> {
        return await http.get(`/restaurant/${string_id}/second_menus`)
    },

    /**
     * 查询 所有 second_menu 资源
     * @param string_id 参数
     */
    async get_restaurant_string_id_second_menu_id(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<FirstMenu[]>> {
        const { string_id, id } = params;
        return await http.get(`/restaurant/${string_id}/second_menu/${id}`)
    },

    /**
     * 根据 id 修改 second_menu资源
     * @param params 参数
     */
    async patch_restaurant_string_id_second_menu_id(params: Omit<SecondMenu, 'dishDynamicInfos' | 'secondMenuStrings'> & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, dmi_slu_id: id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/second_menu/${id}`, {
            ...rest
        })
    },

    /**
     * 根据 second_menu.dmi_slu_id 删除 单个 second_menu 资源
     * @param params 参数
     */
    async delete_restaurant_string_id_second_menu_id(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id } = params;
        return await http.delete(`/restaurant/${string_id}/second_menu/${id} `, {
        })
    },

    /**
     * 根据 ids 删除 多个 second_menu 资源
     * @param params 参数
     */
    async delete_restaurant_string_id_second_menus(params: { string_id: string, ids: number[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/second_menus `, {
            data: {
                ids
            }
        })
    },

    /**
     * 根据 ids 删除 多个 second_menu_string 资源
     * @param params 参数
     */
    async delete_restaurant_string_id_second_menu_second_menu_strings(params: { string_id: string, ids: number[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/second_menu/second_menu_strings `, {
            data: {
                ids
            }
        })
    },
}


















